<template>

  <div>
    <transition appear @before-enter="$animations.beforeEnterLogoArea" @enter="$animations.enterLogoArea">
      <Logo></Logo>
    </transition>
    <div class="opacity-select-card card px-3 py-5 cardWidth ">
      <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
        <!-- <Welcome></Welcome> -->
        <div class="columns is-centered">
          <div class="column">

            <p :class="`has-text-centered mx-3 ${$root.selectedLanguage === `ta`
                ? `ta-sub-line`
                : $root.selectedLanguage === `si`
                  ? `si-sub-line`
                  : `en-sub-line`
              }`"
            style="font-family: OpenSans-Regular"> {{ $root.selectedLanguageData.digital_onboarding }}
            </p>

            <p :class="`has-text-centered mx-3 applicationText ${$root.selectedLanguage === `ta`
                ? `ta-line`
                : $root.selectedLanguage === `si`
                  ? `si-line`
                  : `en-line`
              }`"
               style="font-family: OpenSans-Bold">
              {{ $root.selectedLanguageData.application_status_check }}</p>

          </div>
        </div>
      </transition>
      <div class="column is-two-thirds" style="margin: auto; height:80%">
        <figure class="image 2by1">
          <img src="../assets/images/Layer_1.png">
        </figure>
      </div>

      <p class="has-text-centered en-sub-line " style="font-family: OpenSans-Regular;font-size:1.2rem" >{{ $root.selectedLanguageData.check_your_application_status_by_entering }}</p>
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="">
          <div class="columns is-flex-direction-column">
            <div class="column is-two-thirds" style="margin: auto;">
              <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                }`">{{ $root.selectedLanguageData.nic_number }}<span class="has-text-danger">*</span>
              </label>
              <b-field>
                <p class="control has-icons-right">
                  <ValidationProvider name="NIC" :rules="{nicValidate:true,multiRegex: [/^([0-9]{9}[Xx||Vv])$/, /^[0-9]{12}$/], required : true}" v-slot="{ errors }">
                    <b-input type="text" v-model="$root.formData.userEnteredNic" @focus="$inputFocused('userEnteredNic')"
                      @input="
                        () => {
                          $inputChanged('userEnteredNic');
                          // calName();
                        }
                      " @blur="$inputBlured('userEnteredNic')" />
                    <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/id_logo.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </p>
              </b-field>

              <div class="buttons-class is-justify " style="margin: auto;" >
              <b-button @click="$router.push(`/`)"
                  :class="` buttonwidthBack ${$root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`"

              >{{ $root.selectedLanguageData.back }}

              </b-button>
              <b-button :class="`is-primary buttonwidthContinue   ${$root.selectedLanguage === `ta`
                  ? `continue-button-ta`
                  : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`" :disabled="invalid"
                        @click="verifyNicExistsStatusCheck()" style="width: 68%"
              >{{ $root.selectedLanguageData.getStarted }}

              </b-button>
            </div>


          </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>

import Logo from "./NsbKycLogo.vue";

export default {
  components: {
    Logo,
  },

  methods: {
    validateUserEnterdName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",

      };
      return obj;
    },
    // goToInfoPage: function(){
    //   this.$root.formData.userEnterdName = 
    // } 

    verifyNicExistsStatusCheck() {
      /*this.splitNic();*/
       // initially set as not exist

      /*this.splitNic();
*/
      var isNicExist = false;
      this.continueButtonIsLoading = true;
      window.element = this;
      var identificationNumber = "";
      identificationNumber = this.$root.formData.userEnteredNic;

      try {
       /* let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
  */      this.$http
            .post(this.$baseURL + "/verifyNicExistsStatusCheck", {
              nicNumber: identificationNumber,

            })/*,{
              headers:{'X-token':kyc_token}
            })*/
            .then((response) => {
              console.log(response);


              // enable continue button after the response
              this.continueButtonIsLoading = false;
              isNicExist = response.data.success
              if (isNicExist) {
                console.log("nic no",identificationNumber);
                //const email = response.data.data.email;
                this.$root.formData.statusEmail= response.data.data.email;
                this.$root.formData.statusNic= identificationNumber;
                this.$buefy.toast.open({
                  message: "Entered NIC exsists",
                  type: "is-primary",
                });
                this.$router.push( 'otp')

                console.log("email", this.$root.formData.statusEmail);
              } else {
                this.$buefy.toast.open({
                  message: "Entered NIC Not exsists",
                  type: "is-danger",
                });
                this.$router.push("/");
              }


            })

      } catch (e) {
        console.log(
            "Exception occurred in EnterNIC - VerifyNicExist() ------------------"
        );
        console.log(e.message);

        this.$buefy.toast.open({
          message: "Failed to verify NIC/Passport",
          type: "is-danger",
        });

        // remove loading state from the continue button
        this.continueButtonIsLoading = false;
      }
    },


  },
  mounted: function () {
    this.$root.isFromStatusCheck = 0 ;
  }

}

</script>

<style scoped>
.cardWidth {
  width: 55%;
  margin: 0 auto 80px auto;
  margin-top: 50px;
}
@media (max-width: 500px) {
 .applicationText{
   font-size:2rem;
 }
  .cardWidth{
    width:80%;
  }
  .buttonwidthBack{
    width: 27%;
  }
  .buttonwidthContinue{
    width: 58%;
  }
}
</style>